
class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        
        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on("click", '[data-click="ga-send-select"]', this.handleSelectColor.bind(this));
        this.delegateBody.on("click", '.Upsell__Container [data-action="ga-send-select"]', this.handleSelectUpsell.bind(this));
        this.delegateBody.on("click", '[data-action="toggle-tab"]', this.toggleDetailsTab.bind(this));
        this.delegateBody.on("click", '.ProductSliderCell, .ProductSlider--Thumb', this.handleProductPictureClick.bind(this));

        // Bundle PDP (blocks/_bundle-*.liquid, assets/bundle.js)
        this.delegateBody.on("click", '[data-bundle-id][data-action="handle-reload"]', this.handleBundleTypeClick.bind(this));
        this.delegateBody.on("click", '[data-action="toggle-bundle-selector"], [data-action="toggle-bundle-summary"]', this.handleBundleStepToggle.bind(this));
        this.delegateBody.on("click", '[data-action="toggle-color-picker"]', this.handleBundleColorToggle.bind(this));
        this.delegateBody.on("click", '[data-action="pick-color"]', this.handleBundleColorClick.bind(this));

        document.addEventListener("swiper:image-changed", this.handleProductPictureClick.bind(this));
        document.addEventListener('variant:changed:gtm', this.handleVariantChange.bind(this));
        document.addEventListener("DOMContentLoaded", this.setTrackingConsent.bind(this));

        document.addEventListener('add-to-cart-with-source', this.setAtcSource.bind(this))

    }

    setAtcSource(event){
        const source = event.detail?.source || null;
        const productForm = document.querySelector('.pm__atc-form[data-product-form]');
        //console.log('custom add-to-cart-with-source event fired', source);

        if (!productForm) return;
        const mainButton = productForm.querySelector('.pm__atc-button--main');
        
        if (!mainButton) return;

        // Trigger click na main button ali sa source
        mainButton.dataset.atcSource = source; // setujemo data-source da productAdded može da pročita
        mainButton.click();
    }

    setTrackingConsent() {
        function setConsentCookie(event, detail) {
            detail = detail || event?.detail;
            if (!detail) return;
            
            var flag = '0';
            flag += detail.preferencesAllowed ? 'F' : 'f';
            flag += detail.analyticsAllowed ? 'A' : 'a';
            flag += detail.marketingAllowed ? 'M' : 'm';
            document.cookie = '_tracking_consent=' + flag + '.0; path=/; SameSite=Lax';
        }

        // When user accepts/denies cookies, persist to _tracking_consent cookie
        // then fire consent_ready so GTM Consent Update tag re-evaluates
        document.addEventListener('visitorConsentCollected', setConsentCookie);

        // Load Shopify Customer Privacy API (needed for cookie banner to show)
        // If returning visitor has no _tracking_consent cookie, set it from Shopify's stored consent
        if (!window.Shopify || !window.Shopify.loadFeatures) return;

        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
            if (document.cookie.match(/_tracking_consent=/)) return;

            const customerPrivacy = window?.Shopify?.customerPrivacy;
            const shouldShowBanner = customerPrivacy?.shouldShowBanner?.();

            // If banner won't show (e.g. US markets), default to granted.
            if (shouldShowBanner === false) {
                setConsentCookie(null, {
                    preferencesAllowed: true,
                    analyticsAllowed: true,
                    marketingAllowed: true
                });
                return;
            }

            const consent = customerPrivacy?.currentVisitorConsent?.();
            if (!consent) return;

            setConsentCookie(null, {
                preferencesAllowed: consent.preferences === 'yes',
                analyticsAllowed: consent.analytics === 'yes',
                marketingAllowed: consent.marketing === 'yes'
            });
        });
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleVariantChange(event) {
       
        const data = JSON.parse(
            document.querySelector('product-component script[type="application/ld+json"]').textContent
        );
        data.ecommerce.items[0].item_variant = event.detail.title || "Default Title";
        data.ecommerce.items[0].item_id = event.detail.sku || "";
        data.ecommerce.items[0].item_sku = event.detail.sku || "";
        data.ecommerce.items[0].price = event.detail.price / 100;
        

        const quantity = parseInt(document.querySelector('.pm__quantity-input')?.value) || 1;

        data.ecommerce.items[0].quantity = quantity;
        data.ecommerce.value = event.detail.price / 100 * quantity;
        if (!dataLayer || !data) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);

      
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

                if (!dataLayer || !data) return;

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

              //console.log(data, "And pushed to dataLayer");
            }
        });
    }


    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;
    
        window.fetch = async function (...args) {
            let [url, options] = args;
            let capturedRequestDataForEvent = null;
    
            try {
                if ((typeof url === 'object' && url !== null) || !(url.includes("/cart") || url.includes(".js"))) {
                    return originalFetch.apply(this, args);
                }
                
                if (url && url.includes(`/cart/add.js`) && options && options.body) {
                    if (options.body instanceof FormData) {
                        capturedRequestDataForEvent = {
                            id: options.body.get('id'),
                            quantity: options.body.get('quantity'),
                            category: options.body.get('category'),
                            category2: options.body.get('category2'),
                            list_id: options.body.get('list_id'),
                            list_name: options.body.get('list_name'),
                            source: options.body.get('source')
                        };
    
                        const category = capturedRequestDataForEvent.category;
                        const category2 = capturedRequestDataForEvent.category2;
                        const list_id = capturedRequestDataForEvent.list_id;
                        const list_name = capturedRequestDataForEvent.list_name;
    
                        if (category) {
                            options.body.append('properties[_category]', category);
                        }
                        if (category2) {
                            options.body.append('properties[_category2]', category2);
                        }
                        if (list_id) {
                            options.body.append('properties[_list_id]', list_id);
                        }
                        if (list_name) {
                            options.body.append('properties[_list_name]', list_name);
                        }

                    } else if (typeof options.body === 'string') {
                         const contentType = options.headers ? (options.headers['Content-Type'] || options.headers['content-type']) : null;
                         if (contentType && contentType.includes('application/json')) {
                            try {
                                let requestPayload = JSON.parse(options.body);
                                capturedRequestDataForEvent = {
                                    id: requestPayload.id,
                                    quantity: requestPayload.quantity,
                                    category: requestPayload.category,
                                    category2: requestPayload.category2,
                                    list_id: requestPayload.list_id,
                                    list_name: requestPayload.list_name,
                                    source: requestPayload.source
                                };
    
                                if (requestPayload && (
                                    capturedRequestDataForEvent.category ||
                                    capturedRequestDataForEvent.category2 ||
                                    capturedRequestDataForEvent.list_id ||
                                    capturedRequestDataForEvent.list_name
                                    )) {
    
                                    requestPayload.properties = requestPayload.properties || {};
                                    if (capturedRequestDataForEvent.category) {
                                        requestPayload.properties['_category'] = capturedRequestDataForEvent.category;
                                    }
                                    if (capturedRequestDataForEvent.category2) {
                                        requestPayload.properties['_category2'] = capturedRequestDataForEvent.category2;
                                    }
                                    if (capturedRequestDataForEvent.list_id) {
                                        requestPayload.properties['_list_id'] = capturedRequestDataForEvent.list_id;
                                    }
                                    if (capturedRequestDataForEvent.list_name) {
                                        requestPayload.properties['_list_name'] = capturedRequestDataForEvent.list_name;
                                    }
    
                                    options.body = JSON.stringify(requestPayload);
                                    if (options.headers && (options.headers['Content-Length'] || options.headers['content-length'])) {
                                        options.headers['Content-Length'] = new TextEncoder().encode(options.body).length.toString();
                                    }
                                }
                            } catch (e) {
                                console.warn('Fetch interceptor: Failed to parse/modify assumed JSON body for /cart/add.js', e);
                            }
                        }
                    }
                }
    
                if (url && url.includes(`/cart/clear.js`)) _this.cartClear();
    
                const response = await originalFetch.apply(this, args);
                const originalResponse = response;
                const responseClone = response.clone();
    
                if (!responseClone.ok) {
                     console.warn(`Workspace interceptor: Request to ${url} failed with status ${responseClone.status}`);
                    return originalResponse;
                }
    
                 if (
                     url === '' ||
                     typeof dataLayer === 'undefined' ||
                     !(
                         url.includes(`/cart/add.js`) ||
                         url.includes(`/cart/change.js`) ||
                         url.includes(`/cart/update.js`)
                     )
                 ) {
                     return originalResponse;
                 }
    
                let json = null;
                try {
                     json = await responseClone.json();
                } catch (e) {
                    console.error('Fetch interceptor: Failed to parse JSON response from cart API', e, await responseClone.text());
                    return originalResponse;
                }
    
                if (url && url.includes(`/cart/add.js`)) {
                    _this.cartAdd(json, capturedRequestDataForEvent);
                } else if (url && (url.includes(`/cart/change.js`) || url && url.includes(`/cart/update.js`))) {
                    _this.cartUpdate(json);
                }
    
                return originalResponse;
    
            } catch (e) {
                console.error('Fetch interceptor critical error:', e);
                return originalFetch(...args);
            }
        };
    }

    async cartAdd(cart, requestPayload) {
        cart.items ? this.productAdded(cart.items, requestPayload) : this.productAdded([cart], requestPayload);
    }

    async cartUpdate(cart) {
        this.productAdded(cart.items_added);
        this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    async productAdded(cartItems, requestPayload) {
        if (!cartItems || !cartItems.length) return;

        requestPayload = requestPayload || {};
        const items = [];
        let totalPrice = 0;

        for (const item of cartItems) {
            totalPrice += item.price / 100;
            const quantity = parseInt(requestPayload.quantity, 10) || item.quantity || 1;

            items.push({
                'item_sku': item.sku,
                'item_id': item.sku || item.id.toString(),
                'id': item.id.toString(),
                'item_name': item.untranslated_product_title,
                'item_brand': item.vendor.replace('®', '').trim(),
                'item_category': requestPayload.category,
                'item_category2': requestPayload.category2,
                'item_list_id': requestPayload.list_id,
                'item_list_name': requestPayload.list_name,
                'item_variant': item.untranslated_variant_title || "Default Title",
                'discount': item.total_discount / 100,
                'price': item.presentment_price,
                'quantity': quantity,
                'google_business_vertical': "retail"
            });
        }

        // Standard event
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                value: totalPrice,
                currency: window.Shopify.currency.active,
                items: items
            }
        });

        // Special source event: only when add-to-cart was from sticky bar
        if (requestPayload.source === 'sticky_add_to_cart') {
            dataLayer.push({ ecommerce: null });
            const stickyPayload = {
                event: requestPayload.source,
                ecommerce: {
                    value: totalPrice,
                    currency: window.Shopify.currency.active,
                    items: items
                }
            };
            dataLayer.push(stickyPayload);
        }

       // console.log(dataLayer);
    }
    

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const items = [];
        let totalPrice = 0;

        cartItems.forEach(item => {
            const price = Shopify.formatMoney(item.price, '{{amount}}');
            totalPrice += price;

            items.push({
                'item_id': item.sku,
                'item_variant': item.variant_title,
                'item_name': item.product_title,
                'price': price,
                'quantity': parseInt(item.quantity)
            })
        })

        dataLayer.push({
            event: "remove_from_cart",
            remove: {
                value: totalPrice,
                items: items
            },
        });

    }


    handleSelectItem(event) {
        let target = event.target.closest('[data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        dataLayer.push({
            event: "select_item",
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            selected_items: [
                {
                    item_id: settings.item_id,
                    item_name: settings.item_name,
                    price: settings.price,
                    item_list_id: settings.list_id,
                    item_list_name: settings.list_name,
                },
            ],
        });

        const name = settings.list_name?.toLowerCase();
        if (name === 'product recommendations' || name === 'product carousel') {
            this.handleRecomendedProductClick(settings);
        }
    }

    handleRecomendedProductClick(settings) {
        if (!settings) return;

        dataLayer.push({
            event: "product_recommended_product_click",
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            selected_items: [
                {
                    item_id: settings.item_id,
                    item_name: settings.item_name,
                    price: settings.price,
                    item_list_id: settings.list_id,
                    item_list_name: settings.list_name,
                }
            ],
        });
    }


    handleSelectUpsell(event){
        let target = event.target.closest('.Upsell__Container [data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        dataLayer.push({
            event: "click_upsell_cart",
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            selected_items: [
                {
                    item_id: settings.item_id,
                    item_name: settings.item_name,
                    price: settings.price,
                    item_list_id: settings.list_id,
                    item_list_name: settings.list_name,
                },
            ],
        });
       //console.log(dataLayer)
    }

    handleSelectColor(event) {
        let target = event.target.closest('[data-click="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        dataLayer.push({
            event: "click_color_product",
            selected_item_list_id: settings.list_id,
            selected_item_list_name: settings.list_name,
            selected_items: [
                {
                    item_id: settings.item_id,
                    item_name: settings.item_name,
                    price: settings.price,
                    item_list_id: settings.list_id,
                    item_list_name: settings.list_name,
                },
            ],
        });
        //console.log(dataLayer)
    }

    toggleDetailsTab(event){
        const target = event.target.closest('[data-action="toggle-tab"]');
        if (!target || !window.dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings || '{}');
        if (!settings) return;

        const tabId = target.dataset.tabId;

        // probamo da nađemo content taba
        const panel =
            document.querySelector(`[data-id="${tabId}"]`) ||
            document.getElementById(tabId);

        const eventIs = panel && panel.querySelector('dropdown-product-recommendations')
            ? 'product_bundle_tab'
            : 'product_details_tab';

        dataLayer.push({
            event: eventIs,
            selected_item_list_name: settings.list_name,
            selected_detail_tab_id: target.textContent.trim()
        });
       //console.log(dataLayer)
    }

    handleProductPictureClick(event) {

        let target = null;

        // klik sa slike / thumb-a
        if (event.type === 'click') {
            target = event.target.closest('.ProductSliderCell, .ProductSlider--Thumb');
        }

        // swiper custom event
        if (event.type === 'swiper:image-changed') {
            target = event.detail?.slide;
        }

        if (!target || typeof window.dataLayer === 'undefined') return;

        const productId    = target.dataset.productId || null;
        const productName  = target.dataset.productName || null;
        const productPrice = target.dataset.productPrice || null;

        window.dataLayer.push({
            event: 'product_picture',
            ecommerce: {
            items: [
                {
                item_id: productId,
                item_name: productName,
                price: productPrice
                }
            ]
            }
        });

        // console.log('product_picture fired', {
        //     productId,
        //     productName,
        //     productPrice,
        //     source: event.type
        // });
    }

    /**
     * Reports a step 1 pick on the bundle PDP — the shopper chose a bundle other
     * than the one showing. The card for the current bundle is not a link and
     * selects nothing, so the selector leaves it out.
     *
     * The tracking spec defines no parameters for this event.
     *
     * @param {Event} event - the click event.
     * @param {HTMLElement} target - the bundle card that was pressed.
     */
    handleBundleTypeClick(event, target) {
        this.pushBundleEvent({
            event: 'product_select_bundle_type_click'
        });
    }

    /**
     * Reports the bundle PDP's step 1 or step 3 accordion opening or closing.
     *
     * The step's own listener in bundle.js sits lower in the tree, so it has
     * already flipped aria-expanded by the time the click bubbles up to body.
     * What is read here is the state the shopper has just put the step in.
     *
     * Step 2's own header is not reported. Its expand and collapse events belong
     * to the product rows inside it, see handleBundleColorToggle.
     *
     * The tracking spec defines no parameters for these events.
     *
     * @param {Event} event - the click event.
     * @param {HTMLElement} target - the step's toggle button.
     */
    handleBundleStepToggle(event, target) {
        const steps = {
            'toggle-bundle-selector': 'type',
            'toggle-bundle-summary': 'included'
        };
        const step = steps[target.dataset.action];
        const isOpen = target.getAttribute('aria-expanded') === 'true';

        this.pushBundleEvent({
            event: `product_select_bundle_${step}_${isOpen ? 'expand' : 'collapse'}`
        });
    }

    /**
     * Reports one product's colour row in step 2 opening or closing.
     *
     * Only the row that was pressed is reported. Opening a row closes whichever
     * other one was open, but the shopper did not collapse that one, and rows
     * BundleColors opens by itself are not reported either.
     *
     * As with the step accordions, BundleColors has already flipped the row's
     * aria-expanded by the time the click reaches body.
     *
     * bundle_color_count is the tracking spec's name for the product whose
     * colours are being shown or hidden. It is not a number, whatever the name
     * suggests.
     *
     * @param {Event} event - the click event.
     * @param {HTMLElement} target - the row's toggle button.
     */
    handleBundleColorToggle(event, target) {
        const isOpen = target.getAttribute('aria-expanded') === 'true';

        this.pushBundleEvent({
            event: `product_select_bundle_color_${isOpen ? 'expand' : 'collapse'}`,
            bundle_color_count: this.bundleItemName(target)
        });
    }

    /**
     * Reports a colour picked in step 2 of the bundle PDP.
     *
     * bundle_color_count is the tracking spec's name for the product and colour
     * picked together, e.g. "Pregnancy Pillow - Dusty Pink". Here too it is not
     * a number. It is the colour product's own title, the swatch's data-value:
     * that names both already, and is what the app puts on the order. Prefixing
     * the row's name instead would repeat the product whenever a colour's
     * display name falls back to that same title.
     *
     * A sold-out swatch can still be pressed but picks nothing, so it is not
     * reported either.
     *
     * @param {Event} event - the click event.
     * @param {HTMLElement} target - the swatch that was pressed.
     */
    handleBundleColorClick(event, target) {
        if (target.getAttribute('aria-disabled') === 'true') return;

        this.pushBundleEvent({
            event: 'product_select_bundle_color_click',
            bundle_color_count: target.dataset.value
        });
    }

    /**
     * Reads the visible name of the step 2 row an element belongs to, which
     * BundleColors replaces with the app's Dropdown title once it is bound.
     *
     * @param {HTMLElement} element - anything inside one product's colour row.
     * @returns {string} the row's name, or an empty string outside a row.
     */
    bundleItemName(element) {
        const picker = element.closest('.bundle-colors__picker');
        const name = picker ? picker.querySelector('.bundle-colors__name') : null;

        return name ? name.textContent.trim() : '';
    }

    /**
     * Sends one bundle PDP event to GTM and logs it, so the payload can be
     * checked in the console while the tracking is being tested.
     *
     * @param {Object} payload - the dataLayer entry, including its event name.
     */
    pushBundleEvent(payload) {
        if (!window.dataLayer) return;

        window.dataLayer.push(payload);
        console.log('[GTM bundle]', payload.event, payload);
    }

}

new gTagEvents();